class CartDrawerSizePrompt extends HTMLElement {
  connectedCallback () {
    try {
      this.items = JSON.parse(this.dataset.cartItems) || []
    } catch (err) {
      console.error(err)
      return
    }

    if (this.items.length === 0) {
      return
    }

    this.sizeGuideButton = this.querySelector('[data-action="guide"]')
    this.chatButton = this.querySelector('[data-action="chat"]')

    this.togglePrompt()
    this.connectActions()
  }

  togglePrompt () {
    if (this.shouldShowPrompt()) {
      this.removeAttribute('aria-hidden')
    } else {
      this.setAttribute('aria-hidden', 'true')
    }
  }

  shouldShowPrompt () {
    try {
      return this.items
        .filter((item) => !item.product_has_only_default_variant)
        .map((item) => {
          let size = item.options_with_values.reduce((value, option) => {
            if (option.name === 'Size') {
              value = option.value
            }
            return value
          }, '')

          // Handle sets values
          if (item.properties._setBottomValue) {
            size = item.properties._setBottomValue?.split('/')[1].trim()
          }

          if (item.properties._setTopValue) {
            size = `${size}:${item.properties._setTopValue?.split('/')[1].trim()}`
          }

          return {
            id: item.product_id,
            size,
          }
        })
        .reduce((show, current, idx, items) => {
          items.forEach((item) => {
            if (!show && current.id === item.id && current.size !== item.size) {
              show = true
            }
          })

          return show
        }, false)
    } catch (err) {
      return false
    }
  }

  connectActions () {
    if (this.chatButton) {
      this.chatButton.addEventListener('click', (evt) => {
        evt.preventDefault()
        this.closest('cart-drawer').close()
        const chatWidget = document.querySelector('[data-chat-widget].appear')
        if (chatWidget) {
          chatWidget.click()
        }
      })
    }

    if (this.sizeGuideButton) {
      this.sizeGuideButton.addEventListener('click', (evt) => {
        evt.preventDefault()
        this.closest('cart-drawer').close()
      })
    }
  }
}

customElements.define('cart-drawer-size-prompt', CartDrawerSizePrompt)
